export var ANALYTICS_ANSWER_KEY = 'APT_ANALYTICS_ANSWER_KEY';
export var ANALYTICS_CONSENT_KEY = 'APT_ANALYTICS_CONSENT_KEY';
export var shouldShow = function (path) {
    if (path === void 0) { path = (location === null || location === void 0 ? void 0 : location.pathname) || ''; }
    return (path === null || path === void 0 ? void 0 : path.includes('signup')) || (path === null || path === void 0 ? void 0 : path.includes('token')) || path === '/';
};
export var isAnalyticsEnabled = function () {
    var hasAnswered = localStorage.getItem(ANALYTICS_ANSWER_KEY);
    var hasConsented = localStorage.getItem(ANALYTICS_CONSENT_KEY);
    if (hasAnswered === 'true' && hasConsented === 'true') {
        return true;
    }
    else {
        if (shouldShow()) {
            return true;
        }
    }
    return false;
};
